<template>

	<v-app>
		<div v-if="$store.state.loader" id="loader">
			<div class="loader">
				<GridLoader :color="color" :size="size" :margin="margin" :radius="radius" width="2px" height="10px">
				</GridLoader>
			</div>
		</div>
		<!-- 	Barra de Navegación	 -->
		<BarNav
			v-if="currentRoute != '/login' && currentRoute != '/registro' && currentRoute != '/passwordReset' && ruta != 'eventos/seleccionpuesto' && !currentRoute.startsWith('/carts/')">
		</BarNav>


		<transition appear name="fade">
			<router-view></router-view>
		</transition>
		<Login v-if="
			!$store.state.user.accessToken && $store.state.modalLogin
		"></Login>
		<Register v-if="
			!$store.state.user.accessToken && $store.state.modalRegister
		"></Register>
		<Factura v-if="
			$store.state.user.accessToken != null &&
			$store.state.modalFactura
		"></Factura>
		<!-- <Aliados></Aliados> -->
		<Footer
			v-if="currentRoute != '/login' && currentRoute != '/registro' && currentRoute != '/passwordReset' && ruta != 'eventos/seleccionpuesto' && !currentRoute.startsWith('/carts/')">
		</Footer>
		<!-- <whatsapp-icon/> -->
	</v-app>
</template>

<script>
import WhatsappIcon from "./components/Templates/WhatsappIcon.vue";
import MenuPublic from "./components/fragments/MenuPublic.vue";
import GridLoader from "vue-spinner/src/GridLoader.vue";
import Footer from "./components/fragments/Footer.vue";
import Login from "./components/Loginold.vue";
import Register from "./components/Register.vue";
import Factura from "./components/utils/Factura.vue";
import MenuPublicHome from "./components/fragments/MenuPublicHome.vue";
import BarNav from "./components/fragments/BarNav.vue";
import Aliados from "./components/fragments/Aliados.vue";
import ResultadoFiltro from "./components/fragments/ResultadoFiltro.vue";


export default {
	mounted() {
		var self = this;
		$("#app").ready(function () {
			self.$store.commit("changeLoader", false);
		});
	},
	watch: {
		$route(to, from) {
			this.currentRoute = window.location.pathname;
			this.ruta = this.currentRoute.split("/")
			this.ruta = this.ruta[1] + "/" + this.ruta[2]
		}
	},
	components: {
		GridLoader,
		MenuPublic,
		Footer,
		Login,
		Register,
		Factura,
		WhatsappIcon,
		MenuPublicHome,
		BarNav,
		Aliados,
		ResultadoFiltro,
	},
	data() {
		return {
			color: "#ffcb30",
			size: "30px",
			margin: "5px",
			radius: "100%",
			currentRoute: window.location.pathname,
		};
	},
};
</script>

<style>
.contenedor {
	display: flex;
	flex-direction: column;
	flex: 0 1 auto;
	align-items: stretch;
	height: 100%;
	width: 100%;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.6s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

div#loader {
	position: fixed;
	height: 100%;
	width: 100%;
	z-index: 9999999999999;
	text-align: center;
	background-color: rgba(236, 236, 236, 0.541);
	top: 0;
}

#loader .loader {
	display: -webkit-inline-box;
	padding-top: 20%;
}

/*.v-table__overflow {
	    padding: 0px 30px;
	    max-height: 300px !important;
	    overflow: scroll !important;
	}*/


* {
	font-family: "Montserrat", "Cabin", sans-serif;
}

body {
	background-color: #ececec !important;
	line-height: 1;
}

.cont-flotante {
	box-shadow: 0px 0px 10px #dedede;
	border-radius: 5px;
}

a:hover {
	color: inherit !important;
	text-decoration: none !important;
}

.v-application--wrap {
	min-height: auto !important;
	min-width: 100%;
}

.area_mapeadaAuditorio2 img {
	display: block;
}
</style>
